import { schema } from 'normalizr';

const senderAggResult = new schema.Entity( 'aggResultsBySender', {}, {
    idAttribute: ( value ) => value.sender.id,
    mergeStrategy: ( entityA, entityB ) => ( {
        ...entityA,
        ...entityB,
        countsByDomain: { ...entityA.countsByDomain, ...entityB.countsByDomain }
    } ),
    processStrategy: ( value ) => {
        const { domainName, sender, ...rest } = value;
        const { verified, ...senderDetails } = sender;
        return {
            ...senderDetails,
            countsByDomain: {
                [domainName]: {
                    ...rest,
                    verified
                }
            }
        };
    },
} );

const domainAggResult = new schema.Entity( 'aggResultsByDomain', {}, {
    idAttribute: 'domainName',
    mergeStrategy: ( entityA, entityB ) => ( {
        ...entityA,
        ...entityB,
        countsBySender: { ...entityA.countsBySender, ...entityB.countsBySender }
    } ),
    processStrategy: ( value ) => {
        const { domainName, sender, ...rest } = value;
        return {
            countsBySender: { [sender.id]: { ...rest, sender } },
            domainName,
        };
    },
} );

export const senderAggResultSchema = [ senderAggResult ];
export const domainAggResultSchema = [ domainAggResult ];
